<template>
 
<div class="p-inputgroup">
    <span class="p-inputgroup-addon">{{label}}</span>
    <PrimeDropdown
      v-model="value"
      :options="options"
      placeholder="選擇"
      @change="onChange($event)"
    />
  </div>
</template>


<script>
export default {
  props: ["modelValue","label"],
  emits: ["update:modelValue"],

  data() {
    return {
      options: ["Y", "N"],
      value: null,
    };
  },
   
  created() {
     
    this.value = this.modelValue;
  },
   

  methods: {
   
    onChange() {
      this.$emit("update:modelValue", this.value);
      this.$emit("change", this.value);
    },
  },
};
</script>
